module.exports = __webpack_public_path__ + "static/img/0010.6817e153.png";